import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

interface props {
  title?: string;
}

export default function SetMetaInfo({ title }: props) {

  const { t, i18n } = useTranslation()
  const STATIC_TITLE = !title ? t('metaInfo.title.landing') : title

  return (
    <Helmet>
      <title>{STATIC_TITLE}</title>
      <meta name="description" content={t('metaInfo.description')} />
      <meta name="keywords" content={t('metaInfo.keywords')} />
    </Helmet>
  )

}